<template>
  <b-container fluid>
    <b-row class="justify-content-center">
      <b-col>
        <b-card title="Gestion des adhérents">
          <b-form @submit.prevent="onSubmit">
            <collapse-card :creation-modification="selectedAdherent.id">
              <b-row>
                <b-col lg>
                  <b-form-group
                    :invalid-feedback="veeErrors.first('nom')"
                    label="Nom"
                    label-for="nom"
                    required
                  >
                    <b-form-input
                      id="nom"
                      v-model="selectedAdherent.nom"
                      v-validate="'required|min:4|max:40'"
                      :state="veeErrors.has('nom') ? false : null"
                      name="nom"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg>
                  <b-form-group
                    :invalid-feedback="veeErrors.first('prenom')"
                    label="Prénom"
                    label-for="inputPrenom"
                    required
                  >
                    <b-form-input
                      id="inputPrenom"
                      v-model="selectedAdherent.prenom"
                      v-validate="'required|min:3|max:15'"
                      :state="veeErrors.has('prenom') ? false : null"
                      name="prenom"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg>
                  <b-form-group
                    :invalid-feedback="veeErrors.first('email')"
                    label="Email"
                    label-for="inputEmail"
                    required
                  >
                    <b-form-input
                      id="inputEmail"
                      v-model="selectedAdherent.email"
                      v-validate="'email|max:40'"
                      :state="veeErrors.has('email') ? false : null"
                      name="email"
                      type="email"
                    />
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg>
                  <b-form-group
                    :invalid-feedback="veeErrors.first('adresse')"
                    label="Adresse"
                    label-for="adresse"
                    required
                  >
                    <b-form-input
                      id="adresse"
                      v-model="selectedAdherent.adresse"
                      v-validate="'max:40'"
                      :state="veeErrors.has('adresse') ? false : null"
                      name="adresse"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg>
                  <b-form-group
                    :invalid-feedback="veeErrors.first('codePostal')"
                    label="Code postal"
                    label-for="codePostal"
                    required
                  >
                    <b-form-input
                      id="codePostal"
                      v-model="selectedAdherent.codePostal"
                      v-validate="'max:15'"
                      :state="veeErrors.has('codePostal') ? false : null"
                      name="codePostal"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
                <b-col lg>
                  <b-form-group
                    :invalid-feedback="veeErrors.first('ville')"
                    label="Ville"
                    label-for="ville"
                    required
                  >
                    <b-form-input
                      id="ville"
                      v-model="selectedAdherent.ville"
                      v-validate="'max:30'"
                      :state="veeErrors.has('ville') ? false : null"
                      name="ville"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col lg>
                  <b-form-group
                    :invalid-feedback="veeErrors.first('inputCommentaire')"
                    label="Commentaire"
                    label-for="inputCommentaire"
                    required
                  >
                    <b-form-textarea
                      id="inputCommentaire"
                      v-model="selectedAdherent.commentaire"
                      v-validate="'max:200'"
                      :rows="3"
                      :state="veeErrors.has('inputCommentaire') ? false : null"
                      name="inputCommentaire"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button
                    class="m-1 float-right"
                    type="submit"
                    variant="primary"
                    >Enregistrer
                  </b-button>
                  <b-button
                    class="m-1 float-right"
                    variant="danger"
                    @click="resetForm()"
                    >Annuler
                  </b-button>
                </b-col>
              </b-row>
              <b-col></b-col>
            </collapse-card>
          </b-form>
          <b-row class="justify-content-md-center">
            <b-col sm="auto">
              <b-form-group
                label="Année"
                label-class="font-weight-bold"
                label-for="annee"
              >
                <select
                  v-model="selectedYear"
                  class="form-control"
                  name="annee"
                  @change="findAdherentsByYear()"
                >
                  <option></option>
                  <option v-for="y in years" :key="y" :value="y">
                    {{ y }}
                  </option>
                </select>
              </b-form-group>
            </b-col>
            <b-col sm="auto">
              <b-form-group label=" ">
                <input
                  id="checkbox"
                  v-model="hideSansDon"
                  type="checkbox"
                  @change="filterSansDon()"
                />
                <label for="checkbox"
                  >Cacher ceux qui n'ont pas fait de don</label
                >
              </b-form-group>
            </b-col>
          </b-row>

          <custom-tab
            v-show="adherents.length > 0"
            :tableData="adherents"
            :tableFields="tableFields"
            libelleSuppressionProperty="prenom"
            messageSuppression="Confirmez-vous la suppression de l'adhérent"
            searchable
            @deleteConfirmed="deleteOrDesactivateAdherent"
            @editSelected="selectAdherent"
          ></custom-tab>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ToastService from "../service/toastService";
import ApiService from "@/service/apiService";
import CollapseCard from "../components/CollapseCard";
import CustomTab from "../components/CustomTab";

//Je met ça ici pour épurer l'attribut data
var tableColumns = [
  {
    key: "nom",
    label: "Nom",
    sortable: true,
  },
  {
    key: "prenom",
    label: "Prénom",
    sortable: true,
  },
  {
    key: "email",
    label: "Email",
    sortable: true,
  },
  {
    key: "beautifulAdresse",
    label: "Adresse",
    sortable: false,
  },
  {
    key: "commentaire",
    label: "Commentaire",
    sortable: false,
  },
  {
    key: "don",
    label: "Don (€)",
    sortable: true,
  },
  {
    key: "commentaireDon",
    label: "Commentaire don",
    sortable: true,
  },
  {
    key: "Actions",
    label: "",
  },
];

export default {
  name: "adherent",
  components: {
    CollapseCard,
    CustomTab,
  },
  data() {
    return {
      //Tableau des utilisateurs récupérés du serveur
      adherents: [],

      adherentsBeforeFilter: [],

      //utilisateur sélectionné, utilisé pour passer l'utilisateur lors de la suppression
      selectedAdherent: {},

      //Champs qu'affichera le tableau des utilisateurs
      tableFields: tableColumns,
      //Années des saisies pour choisir le montant et le commantaire
      years: [],
      selectedYear: "",
      //pour filtrer les adhérents
      hideSansDon: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    /**
     * Action aprés la validation du formulaire de creation/modification d'utilisateur
     */
    onSubmit() {
      var vm = this;
      //On vérifie les champs
      this.$validator.validateAll().then((result) => {
        if (result) {
          //Si l'Utilisateur n'a pas d'id il n'existe pas donc on le créé

          ApiService.adherents
            .createUpdate(this.selectedAdherent)
            .then((resp) => {
              ToastService.displaySuccessToast(resp.data.message);
              this.resetForm();
              //On recharge les utilisateurs pour les actualiser
              this.findAdherentsByYear(this.selectedYear);
            });
        }
      });
    },
    /**
     * Méthode appelé aprés la montage du composant
     */
    init() {
      this.findSaisieYears();
    },
    /**
     * Récupére la liste de tous les adhérants d'une année
     */
    async findAdherentsByYear() {
      if (this.selectedYear) {
        var response = await ApiService.adherents.findAdherentsByYear(
          this.selectedYear
        );
        this.adherents = response.data;
        this.adherentsBeforeFilter = response.data;
        this.filterSansDon();
      } else {
        this.adherents = [];
      }
    },
    //Récupère les années des saisies
    async findSaisieYears() {
      var response = await ApiService.saisie.findYears();
      this.years = response.data;
    },
    //filter le tableau des adhérents en fonction des dons
    filterSansDon() {
      if (this.hideSansDon) {
        this.adherents = this.adherents.filter((adherent) => adherent.don);
      } else {
        this.adherents = this.adherentsBeforeFilter;
      }
    },
    /**
     * Envoi la requete de suppression ou desactivation d'un adhérant, ferme la modal et retire l'utilisateur selectionné des utilisateurs de la page
     */
    deleteOrDesactivateAdherent(adherent) {
      ApiService.adherents
        .deleteOrDesactivateAdherent(adherent.id)
        .then((resp) => {
          ToastService.displaySuccessToast(resp.data.message);
          this.findAdherentsByYear(this.selectedYear);
        });
    },
    /**
     * Action lorsqu'une ligne du tableau des utilisateurs est cliqué
     */
    selectAdherent(item) {
      this.resetForm();
      //On copie les attributs de l'objet item
      this.selectedAdherent = Object.assign(this.selectedAdherent, item);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    /**
     * Réinitialise le formulaire
     */
    resetForm() {
      this.selectedAdherent = {};
      this.$validator.reset();
    },
    /**
     * Affecte l'index de la ligne du tableau à la variable actionButtonIndex
     */
    toggleActionButtons(item, index) {
      this.actionButtonsIndex = index;
    },
  },
};
</script>
